import { useContext, useState } from "react";
import { AppContext } from "../hooks/auth/useAppContext";
import { useNavigate } from "react-router-dom";

export default function Footer({ logoFooter, logoDev }) {
  const navigate = useNavigate();
  const appContext = useContext(AppContext);
  const [currentLng, setCurrentLng] = useState(
    window.location.pathname.split("/")[1] || "it"
  );
  function lngHandler(locale) {
    const lng = locale.substr(0, 2).toLowerCase();
    appContext._setters._setLocale(locale);
    localStorage.setItem("lng", lng);
    navigate(`/${lng}`);
    setCurrentLng(lng);
    //window.location.reload();
  }
  return (
    <footer>
      <div className="container">
        <div className="footer-row">
          <div className="wrapper-logo">
            <img src={logoFooter} alt="Hyper Tennis" />
          </div>
          <div className="wrapper-switch-lng">
            <div className="switch-lng">
              {TheApp.Env.LocaleList.map((locale) => (
                <div
                  key={locale}
                  data-locale={locale}
                  className={`lng-item ${
                    currentLng === locale.substr(0, 2).toLowerCase()
                      ? "active"
                      : ""
                  }`}
                  onClick={() => lngHandler(locale)}
                >
                  {locale.substr(0, 2).toUpperCase()}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="footer-row">
          <div className="wrapper-info">
            <p>
              HyperTennis S.R.L.
              <br />
              Sede Legale: Via Vincenzo Vela, 42 - 10128 Torino (TO) - Partita
              IVA: 12521860010 - REA: TO-1296190 <br />
              Codice univoco: USAL8PV -{" "}
              <a href="mailto:hypertennis@pec.it">hypertennis@pec.it</a>
              <br />
            </p>
          </div>
          <div className="wrapper-dev">
            <div>Developed by</div>
            <div>
              <a href="https://www.3x1010.it" target="_blank" rel="noreferrer">
                <img src={logoDev} alt="Developed by 3x1010" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
